import './ccf-favourite-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfFavouriteIconProps extends SvgIconProps  {}
/**
 * This icon will be used to display Favourite agent
 * @param props - CcfFavouriteIconProps
 * @example - <CcfFavouriteIcon />
 * @returns SVG of favorite icon
 */
export function CcfFavouriteIcon(props: CcfFavouriteIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_star_fill" clipPath="url(#clip-ic_star_fill)">
        <path
          id="favorite"
          d="M14.45,17.745a.8.8,0,0,1-.373-.092L10,15.509,5.923,17.652a.8.8,0,0,1-1.161-.843l.779-4.541-3.3-3.216a.8.8,0,0,1,.444-1.364l4.559-.662L9.283,2.9a.832.832,0,0,1,1.434,0l2.039,4.131,4.559.662a.8.8,0,0,1,.444,1.364l-3.3,3.216.779,4.541a.8.8,0,0,1-.788.935Z"
          transform="translate(2 1.885)"
        />
      </g>
    </SvgIcon>
  );
}

export default CcfFavouriteIcon;
